import { render, staticRenderFns } from "./UpdateReviewsPropertyPopup.vue?vue&type=template&id=2b469798&scoped=true&"
import script from "./UpdateReviewsPropertyPopup.vue?vue&type=script&lang=ts&"
export * from "./UpdateReviewsPropertyPopup.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateReviewsPropertyPopup.vue?vue&type=style&index=0&id=2b469798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b469798",
  null
  
)

export default component.exports